import React from "react";
import { Form } from "react-bootstrap";
import styles from "./SliderInput.module.css";
import CommonStyles from "../InputFieldsController/InputFieldsController.module.css";
import IFStyles from "../InputFieldsController/InputFieldsController.module.css"; // same module as wrapper
import {
  FieldProps,
  getFieldContainerStyle,
  getLabelTextStyle,        // same util the wrapper uses
  hasRequiredValidation,    // for the asterisk
} from "../InputFieldsController/InputFieldsController.utils";
import LabeledInputWrapper from "../InputFieldsController/LabeledInputWrapper";

interface SliderInputProps {
  field: FieldProps & {
    toggleOffLabel?: string; // OFF text (builder)
  };
  handleChange: (fieldId: string, event: any) => void;
  handleBlur: (fieldId: string) => void;
  handleSelect: (fieldId: string) => void;
}

const SliderInput: React.FC<SliderInputProps> = ({
  field,
  handleChange,
  handleBlur,
  handleSelect,
}) => {
  const {
    id,
    value,
    disabled,
    show = true,
    isValid = true,
    error,
    selected,
    label,            // ON text = default label
    toggleOffLabel,   // OFF text from builder
  } = field;

  if (!show) return null;

  const containerStyle = getFieldContainerStyle(field);
  const isOn = !!value;

  // Final rule: ON = field.label, OFF = toggleOffLabel (fallback to ON)
  const leftText  = toggleOffLabel ?? "";
  const rightText = label ?? "";

  // match wrapper label’s inline styles + class
  const labelStyle = getLabelTextStyle(field.textStyle);
  const isRequired = hasRequiredValidation(field);

  // hide wrapper’s built-in label so we control left/right labels only
  const wrapperField: FieldProps = { ...field, label: "" };

  return (
    <div style={containerStyle}>
      <LabeledInputWrapper field={wrapperField}>
        <div
          className={`${styles.switchWrapper} ${selected ? CommonStyles.selectedField : ""}`}
          style={{ display: "inline-flex", alignItems: "center", gap: 8 }}
        >
          {/* LEFT (OFF) label — styled exactly like wrapper label */}
          <Form.Label
            htmlFor={id}
            className={`${IFStyles.fieldLabel}`}
            style={{...labelStyle, width: leftText?"auto":0}}
            onClick={(e) => {
              e.stopPropagation();
              handleSelect?.(id);
            }}
          >
            {leftText}
          </Form.Label>

          {/* Switch */}
          <label htmlFor={id} className={styles.switchLabel}>
            <input
              id={id}
              type="checkbox"
              checked={isOn}
              disabled={disabled}
              onChange={(e) => handleChange(id, e)}
              onBlur={() => handleBlur(id)}
              onFocus={() => handleSelect(id)}
              className={styles.nativeCheckbox}
              role="switch"
              aria-checked={isOn}
            />
            <span className={styles.track} />
          </label>

          {/* RIGHT (ON) label — same wrapper style; show required asterisk here (ON = default label) */}
          <Form.Label
            htmlFor={id}
            className={`${IFStyles.fieldLabel}`}
            style={labelStyle}
            onClick={(e) => {
              e.stopPropagation();
              handleSelect?.(id);
            }}
          >
            {rightText}
            {isRequired && <span style={{ color: "red", marginLeft: 5 }}>*</span>}
          </Form.Label>
        </div>

        {!isValid && error && <div className="invalid-feedback d-block">{error}</div>}
      </LabeledInputWrapper>
    </div>
  );
};

export default SliderInput;
